import React from 'react';
import { Check, Minus, ThumbsUp, ThumbsDown } from 'lucide-react';

// «Como foi este exercício?» — um toque, sem teclado, e saltável.
//
// Aparece DEPOIS de o exercício ficar concluído, dentro do próprio ecrã, por cima da navegação. Nunca bloqueia:
// o atleta pode avançar para o exercício seguinte (ou terminar) sem responder, e o «Agora não» fecha o pedido
// sem deixar nada. O que responder fica guardado e o motor usa-o (o «Nunca mais» deixa de ser proposto; o
// «Mais»/«Menos» decide o próximo degrau de carga).
//
// As três respostas dizem, na própria etiqueta, o que fazem — sem jargão e sem «IA».

const OPTIONS = [
  { key: 'more', label: 'Mais', hint: 'quero mais carga', icon: ThumbsUp },
  { key: 'less', label: 'Menos', hint: 'foi demasiado', icon: ThumbsDown },
  { key: 'never', label: 'Nunca mais', hint: 'não quero voltar a fazer este', icon: Minus },
];

export default function FeedbackPrompt({ exercise, value, onSend, busy, onDismiss }) {
  const saved = OPTIONS.find((o) => o.key === value);
  return (
    <section className="wp-feedback" aria-label="Como foi este exercício?" data-testid="feedback-prompt" data-verdict={value || 'none'}>
      <div className="wp-feedback-head">
        <h2 className="wp-feedback-q" data-testid="feedback-question">Como foi este exercício?</h2>
        {saved ? (
          <p className="wp-feedback-saved" role="status" data-testid="feedback-saved">
            <Check size={14} aria-hidden="true" /> Guardado: {saved.label}
          </p>
        ) : (
          <button type="button" className="wp-feedback-skip" onClick={onDismiss} data-testid="feedback-skip">Agora não</button>
        )}
      </div>
      <div className="wp-feedback-actions">
        {OPTIONS.map((o) => {
          const Icon = o.icon;
          const active = value === o.key;
          return (
            <button
              key={o.key}
              type="button"
              className={`wp-feedback-btn${active ? ' is-active' : ''}`}
              data-testid={`feedback-${o.key}`}
              aria-pressed={active}
              disabled={!!busy}
              onClick={() => onSend(o.key)}
            >
              <span className="wp-feedback-label"><Icon size={16} aria-hidden="true" /> {o.label}</span>
              <span className="wp-feedback-hint">{o.hint}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
